import React from "react";
import Chip from "@mui/material/Chip";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

const IaxGroupSummaryDialog = ({ open, onClose, groups }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Grupos de la actividad</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            textAlign: "center",
            display: "flex",
            gap: 1,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          {groups.map((group) => (
            <Chip key={group.id} label={group.nombre} color="default" />
          ))}
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained" autoFocus>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IaxGroupSummaryDialog;
